import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryNav() {
  const location = useLocation();

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 -mt-8 relative z-10">
      <div className="bg-background-100 rounded-xl p-1 flex items-center gap-1 overflow-x-auto">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
              location.pathname === `/category/${cat.slug}`
                ? 'bg-primary-500 text-white'
                : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200'
            }`}
          >
            <i className={`${cat.icon}`}></i>
            {cat.name}
          </Link>
        ))}
      </div>
    </section>
  );
}